var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSuperUser)?_c('div',{staticClass:"container-fluid",attrs:{"id":"admin"}},[_c('Breadcrumb',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('router-view')],1):_c('NotFound')}
var staticRenderFns = []

export { render, staticRenderFns }